/** Versão da Aplicação
 *
 * Altere este valor sempre que houver uma atualização significativa
 * que exija limpeza de cache ou forçar novo login dos usuários.
 *
 * Formato recomendado: MAJOR.MINOR.PATCH ou timestamp
 * Exemplo: "1.0.0", "1.0.1", "2.0.0"
 */
export const APP_VERSION = '1.1.1';

/** Chave usada para armazenar a versão no localStorage. */
export const APP_VERSION_KEY = 'app_version';
